import {
	GoogleSheetsRemoteConfigProvider,
	IRemoteConfigProvider,
	StoredRemoteConfigProvider,
} from '@verv-inc/js-toolkit';

export const remoteConfigIDSearchKey = 'utm_campaign';

export const composeRemoteConfigProvider = (): IRemoteConfigProvider => {
	const sessionCacheConfigKey = 'remote_config';

	return StoredRemoteConfigProvider({
		provider: GoogleSheetsRemoteConfigProvider({
			apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
			sheetId: process.env.REACT_APP_GOOGLE_SHEETS_ID,
		}),
		key: sessionCacheConfigKey,
		storage: window.sessionStorage,
	});
};
